import { render, staticRenderFns } from "./CaseFeedbackModal.vue?vue&type=template&id=0bf2419a&scoped=true"
import script from "./CaseFeedbackModal.vue?vue&type=script&lang=js"
export * from "./CaseFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./CaseFeedbackModal.vue?vue&type=style&index=0&id=0bf2419a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2419a",
  null
  
)

export default component.exports